<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <job-comments-page />
    </div>
  </div>
</template>

<script>
import JobCommentsPage from '../Components/JobCommentsPage.vue';
export default {
  name: 'JobDetails',
  components: {
    'job-comments-page': JobCommentsPage,
  },
};
</script>
